class SearchProductGrid extends HTMLElement {
  constructor() {
    super();
    this.searchProductsData = [];
    this.filterProducts = [];
    this.initProducts = 12;
    this.domain = `${Shopify.routes.root}`;
    this.productsGrid = this.querySelector("#main-collection-product-grid");
    this.searchFilters = document.querySelector('search-filters-form');
    this.listentEvents();
  }

  listentEvents() {
    this.querySelector(".render-products")?.addEventListener(
      "click",
      this.renderProducts.bind(this)
    );
    document.addEventListener("DOMContentLoaded", () => {
      this.loadSearchData();
    });

    window.addEventListener("scroll", () => {
      this.showMoreProducts();
    });
    document.querySelector(".top-link")?.addEventListener(
      "click",
      this.scrollToInit.bind(this)
    );
  }

  scrollToInit() {
    const to = this.querySelector("#main-collection-product-grid");
    const topOffset = to.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: topOffset, behavior: "smooth" });
  }

  loadSearchData() {
    const searchResults = document.querySelector("#searchProducts") ? JSON.parse(document.querySelector("#searchProducts").innerHTML) : [];
    this.filterProducts = searchResults;
    this.searchProductsData = searchResults;
    
    // Process redirects for pack products
    this.searchProductsData.forEach((product) => {
      if (product.title.toUpperCase().includes("PACK")) {
        this.getRedirects(product);
      }
    });
  }

  async getRedirects(product) {
    try {
      const metafields = await fetch(
        `${window.Shopify.routes.root}products/${product.handle}?view=mb_price`
      ).then((response) => response.json());
      product.redirects = metafields.redirects ? metafields.redirects.items : [];
      return product;
    } catch (error) {
      console.log("Error loading redirects:", error);
      return product;
    }
  }

  showMoreProducts = () => {
    const button = document.getElementById("showMoreProducts");
    if (button) {
      const rect = button.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      if (
        rect.bottom <= windowHeight &&
        this.initProducts < this.filterProducts.length
      ) {
        this.renderProducts();
      }
    }
  };

  renderProducts() {
    const renderNewProducts = this.filterProducts.slice(
      this.initProducts,
      this.initProducts + 12
    );
    const showProductsBtn = this.querySelector(".render-products");
    
    // Transform product data to match the expected structure
    const newProductsHTML = renderNewProducts.length > 0 ? renderNewProducts
      .map((prod) => {
        const transformedProduct = {
          ...prod,
          images: Array.isArray(prod.media) ? prod.media : (Array.isArray(prod.images) ? prod.images : []),
          options: Array.isArray(prod.options) ? prod.options.map((option, index) => {
            // If options is already in the correct format, return as is
            if (typeof option === 'object' && option.name && option.values) {
              return option;
            }
            // If options is an array of strings, convert to expected format
            if (typeof option === 'string') {
              const variantOption = prod.variants.map((variant) => {
                return variant[`option${index+1}`];
              });
              const uniqueValues = Array.from(new Set(variantOption));
              return {
                name: option,
                position: index + 1,
                values: uniqueValues
              };
            }
            return option;
          }) : [],
          variants: Array.isArray(prod.variants) ? prod.variants.map(variant => ({
            ...variant,
            price: typeof variant.price === 'string' ? parseFloat(variant.price) / 100 : variant.price / 100,
            compare_at_price: variant.compare_at_price ? (typeof variant.compare_at_price === 'string' ? parseFloat(variant.compare_at_price) / 100 : variant.compare_at_price / 100) : null
          })) : []
        };
        return ProductCardTemplate.newCardTemplate(transformedProduct);
      })
      .join("") : `<h4 class="empty-collection">No products match the filter.</h4>`;

    this.productsGrid.insertAdjacentHTML("beforeend", newProductsHTML);
    
    if (renderNewProducts.length < 12) {
      showProductsBtn?.classList.add("hidden");
    } else {
      if (showProductsBtn?.classList.contains("hidden")) {
        showProductsBtn.classList.remove("hidden");
      }
    }
    
    this.enabledQuickAddBtn();
    this.initProducts += 12;
    this.addUnavaliableSizes();
  }

  addUnavaliableSizes() {
    document.querySelectorAll('.quick-add-options__wrapper').forEach(optionWrapper => {
      const productCard = optionWrapper.closest("product-card");
      const selectedHandle = productCard.getAttribute("data-selected-swatch");
      const quickAdd = productCard.querySelector("quick-add");

      if (quickAdd.querySelectorAll('.quick-add-option').length == 1) {
        productCard.querySelectorAll(".quick-add-option-value").forEach((option) => {
          fetch(`${this.domain}products/${selectedHandle}.js`)
            .then((response) => response.json())
            .then((data) => {
              const product = data;
              const position = option.parentElement.getAttribute("data-option-position");
              const value = option.textContent;
              const filterOptionPosition = position;

              const availableOptions = product.variants
                .filter((variant) => variant[position] == value && variant.available)
                .map((variant) => variant[filterOptionPosition]);

              availableOptions.includes(option.textContent)
                ? option.classList.remove("unavailable")
                : option.classList.add("unavailable");
              this.enabledQuickAddBtn();
            })
            .catch((err) => {
              console.log(err);
            });
        });
      }
    });
  }

  enabledQuickAddBtn() {
    const buttons = this.querySelectorAll(".quick-add-btn");
    buttons.forEach((btn) => {
      const optionsWrapper = btn.querySelector(".quick-add-options__wrapper");
      if (btn) {
        btn.classList.remove("disabled");
        btn.addEventListener("mouseenter", function () {
          optionsWrapper.style.display = "block";
        });
        btn.addEventListener("mouseleave", function () {
          optionsWrapper.style.display = "none";
        });
      }
    });
  }

  // Method to update products when filters are applied
  updateProducts(newProducts) {
    this.filterProducts = newProducts;
    this.productsGrid.innerHTML = "";
    this.initProducts = 0;
    this.renderProducts();
  }
}

customElements.define("search-product-grid", SearchProductGrid); 